import WitnessWelcome from "./WitnessWelcome";
import WitnessFinal from "./WitnessFinal";
import WitnessSolo from "./WitnessSolo";

export default {
    "witness-welcome": WitnessWelcome,
    "witness-final": WitnessFinal,
    "witness-solo": WitnessSolo
}